export const locale = {
    lang: 'en',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': 'Web company profile',
        'TIT_WCP_DAT': 'Access data',
        'CHAN_INF':'Loading information',
        'HELP':'Help',
        'EnlaceWCP':'Copy link to enter company profile',
        'ClaveWCP':'Copy password to enter company profile',
        'PORDUC_CER':{
          '40':'Certify 3.0',
          '1':'Certify',
          '20':'Certify 2.0',
          '75':'GPTW + GCTI'
        },
        'ESTA_WEB_CP':{
          'false':'I do not publish',
          'true':'Public',
        },
        'MODAL':{
          'TIT_MOD':'What is the reason for not publishing it?',
          'BTN_CONT':'Continue',
          'BTN_CANC':'Cancel',
          'RAISON_OBLIG': 'To continue you must enter the reason for non-publication',
          'TIT_CONDI_US':'Terms of Use',
          'TEX1_CONDI_US':'When the company profile is made public, it will be published on the Great Place To Work(r) page with the information that has been configured.Great Place to Work(r) is not responsible for the content, since the data published are the result of information that the company itself has uploaded on the platforms intended for this purpose.',
          'TEX2_CONDI_US':'Also the company agrees that this information will be uploaded to the various search engines that have been contracted to increase the dissemination of the best companies to work for that have been certified by Great Place To Work(r)',
          'TEX3_CONDI_US':'At any time, the company may return the company profile to private mode, which will cause it to no longer appear in the list of certified companies, however, Great Place To Work(r) will not be able to remove the indexing that the search engines have done, so it is likely that for some time the company name will continue to appear within the search results in the different search engines that Great Place To Work works with.',
          'TEX4_CONDI_US':'The publication or non-publication of this company profile is the sole responsibility of the company.',
          'REA_TEX_CONDI_US':'To confirme, please write the following text',
          'NO_DISPO_ARCHI':'The file is not available',
        }

      }
    }
};
